import type { RootState } from "@/services/store";

export const themeSelector = (state: RootState) => state.theme.theme;
